import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-confirm-report-state-change',
  templateUrl: './modal-confirm-report-state-change.component.html',
  styles: [
  ]
})
export class ModalConfirmReportStateChangeComponent extends ExcTranslation implements OnInit {

  @Input() data: any;
  confirmationText = '';
  btnText = '';
  uiModel: any = {
    comment: ''
  };
  constructor(public excRestService: ExcRestService, public modal: ExgModalService, public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    const current = this.enumSvc.getEnumerationText(this.data.enmName, this.data.currentEnmIdent);
    const next = this.enumSvc.getEnumerationText(this.data.enmName, this.data.newEnmIdent);

    this.confirmationText = this.getRessource('ConfirmationText', {
      current,
      next
    });

    this.btnText = this.getRessource('ReportStateActions.' + this.data.btnText);
  }

  cancel(): void {
    this.modal.close();
  }

  save(): void {
    this.modal.action({success: true, comment: this.uiModel.comment || ''});
  }
}
